import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { initScrollReveal } from './utils/scrollReveal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Process from './components/Process';
import Blog from './components/Blog';
import TechnologyStack from './components/TechnologyStack';
import Statistics from './components/Statistics';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import KidsphereDetail from './components/KidsphereDetail';
import SEO from './components/SEO';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import PortfolioPage from './pages/PortfolioPage';
import ProductPage from './pages/ProductPage';
import ContactPage from './pages/ContactPage';

// Home page component
const HomePage = () => (
  <>
    <SEO 
      title="CodeRidge | The Digital Peak — Scaled, Secured, Sustained | Enterprise IT, Cloud & Security"
      description="CodeRidge architects enterprise scale, security, and intelligence: intelligent automation and LLM workflows, zero-trust cybersecurity, Cloud 3.0 on AWS and Azure, and 24/7 managed IT—including our work across products, cloud platforms, and secure experiences. Hyderabad, India. Book a free infrastructure audit."
      keywords="managed IT services, zero trust cybersecurity, cloud migration AWS Azure, hybrid cloud, LLM automation, enterprise security, infrastructure audit, digital transformation, CodeRidge Hyderabad"
      url="https://coderidge.in/"
    />
    <Navbar />
    <Hero />
    <About />
    <Services />
    <Process />
    <TechnologyStack />
    <Statistics />
    <Portfolio />
    <Blog />
    <Testimonials />
    <FAQ />
    <Contact />
    <Footer />
  </>
);

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Reinitialize scroll reveal on route change
    setTimeout(() => {
      initScrollReveal();
    }, 100);
  }, [location.pathname]);

  return (
    <Routes>
        {/* Home Page - Single scroll page with all sections */}
        <Route path="/" element={<HomePage />} />
        
        {/* Individual Pages for Better SEO */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/contact" element={<ContactPage />} />
        
        {/* Legal Pages */}
        <Route 
          path="/privacy" 
          element={
            <>
              <SEO 
                title="Privacy Policy - CodeRidge"
                description="How CodeRidge collects, uses, and protects information when you use our site or engage us for cloud, security, automation, managed IT, and engineering services."
                keywords="privacy policy, data protection, CodeRidge privacy, enterprise services"
                url="https://coderidge.in/privacy"
              />
              <Navbar />
              <Privacy />
              <Footer />
            </>
          } 
        />
        <Route 
          path="/terms" 
          element={
            <>
              <SEO 
                title="Terms & Conditions - CodeRidge"
                description="Terms of use for CodeRidge websites and services—including consulting, product engineering, cloud, cybersecurity, managed IT, and Kidsphere."
                keywords="terms and conditions, terms of service, CodeRidge terms, professional services"
                url="https://coderidge.in/terms"
              />
              <Navbar />
              <Terms />
              <Footer />
            </>
          } 
        />
        
        {/* Product Detail Page */}
        <Route 
          path="/kidsphere-detail" 
          element={
            <>
              <SEO 
                title="Kidsphere in depth | Life-skills EdTech by CodeRidge"
                description="Full overview of Kidsphere: features, life-skills curriculum, parent controls, and how CodeRidge engineers EdTech with enterprise-grade security and reliability practices."
                keywords="Kidsphere features, life skills app, parent dashboard, EdTech security, CodeRidge Kidsphere"
                url="https://coderidge.in/kidsphere-detail"
              />
              <Navbar />
              <KidsphereDetail />
              <Footer />
            </>
          } 
        />
      </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
